import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Typography, Grid, Paper } from '@material-ui/core';

export const EntityMetadataViewer = () => {
  const { entity } = useEntity();

  // Преобразуем объект в массив ключ-значение для удобного отображения
  const renderObject = (obj: Record<string, any>) => {
    return Object.entries(obj).map(([key, value]) => {
      // Если value объект, показываем как JSON
      const displayValue =
        typeof value === 'object' && value !== null
          ? JSON.stringify(value, null, 2)
          : String(value);

      return (
        <Typography key={key} variant="body2">
          <b>{key}:</b> {displayValue}
        </Typography>
      );
    });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper style={{ padding: '16px' }}>
          <Typography variant="h6">Entity Metadata</Typography>
          {renderObject(entity.metadata)}
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper style={{ padding: '16px' }}>
          <Typography variant="h6">Entity Spec</Typography>
          {renderObject(entity.spec)}
        </Paper>
      </Grid>
    </Grid>
  );
};

